<div class="search-view-wrapper">
  <!-- <h2>{{'Select from'}} {{name}}</h2> -->
  <div class="white-box box-shadow">
    <!-- search field -->
    <div class="search-box">
      <div class="search-field">
        <div class="mat-form-field-flex">
          <mat-icon matPrefix>search</mat-icon>
          <input [formControl]="formControl" type="search" placeholder="Search {{name}}" class="search-input"
                 #searchControl>
        </div>
      </div>
    </div>

    <!-- search results -->
    <div class="checkbox-wrapper" id="scrolling">
      <div class="check-box" *ngFor="let item of filteredItems | async">
        <app-skf-checkbox [label]="item[labelKey]"
                          (changeEvent)="updateSelection(item,$event.checked)"
        ></app-skf-checkbox>
      </div>
    </div>
  </div>

  <!-- selection count -->
  <div class="selected-group-box">
    {{selectedItems?.length}} {{name}} {{'selected'}}
  </div>

  <!-- selection chips -->
  <div *ngIf="selectedItems?.length>0" class="selected-label white-box">
    <mat-chip-list>
      <mat-chip
        *ngFor="let item of selectedItems"
        [removable]="!readonly"
        (removed)="remove(item)">
        {{item[labelKey]}}
        <mat-icon matChipRemove *ngIf="!readonly">clear</mat-icon>
      </mat-chip>
    </mat-chip-list>
  </div>
</div>
